
import './App.css';

import {Suspense} from 'react';

import {Canvas} from '@react-three/fiber'

import Sikkim from './Components/Sikkim.js';

import NavbarComponent from './Components/NavbarComponent.js'
import LowestNavbar from './Components/LowestNavbar.js'

import Snowfall from './Components/Snowfall.js';
import AboutMe from './Components/AboutMe.js'
import Skills from './Components/Skills.js';
import WorkExperience from './Components/WorkExperience.js';
import MyProjects from './Components/MyProjects.js';
import ContactMe from './Components/ContactMe.js';
import FunctionalSkills from './Components/FunctionalSkills.js';
import IndustryExperience from './Components/IndustryExperience.js';

//import { OrbitControls } from '@react-three/drei'

//need to generate snowfall.Check GPT

function App() {
const show3D = false;

  return (
    <div className="App">
      <NavbarComponent/>

      <AboutMe/>

     
      <div className="line">
        <hr/>
      </div>
      <Skills/>
      <div className="line">
        <hr/>
      </div>
      <FunctionalSkills/>
      <div>
        <hr/>
      </div>

      
    {show3D && (
  <Canvas camera={{ position: [2, 0, 12.25], fov: 28 }} style={{ background: '#abcdef' }}>
    <ambientLight intensity={1.25} />
    <ambientLight intensity={0.1} />
    <directionalLight intensity={0.4} />
    <hemisphereLight skyColor="#b1e1ff" groundColor="#000000" intensity={1} />
    <Suspense fallback={null}>
      <Sikkim />
      <Snowfall count={250} />
      <IndustryExperience />
    </Suspense>
  </Canvas>
)}
      <div className="line">
        <hr/>
      </div>
      <WorkExperience/>
      <div className="line">
        <hr/>
      </div>
      <MyProjects/>
      <div className="line">
        <hr/>
      </div>
      <ContactMe/>

      <LowestNavbar/>
      
    </div>
  );
}

export default App;
